var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrochet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path-animate",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 21.1113L4.5 19.1152L14.5 29.0957L24 17.6182L37.5 2.14844L41 4.14453L14.5 33.0879L2 21.1113Z",
    fill: "rgba(255,255,255,0)",
    stroke: "#44068B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 110,
    strokeDashoffset: 110
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrochet);
export default __webpack_public_path__ + "static/media/crochet.b2a6953e56dddebba7bc7d2131c5b79e.svg";
export { ForwardRef as ReactComponent };